<template>
  <a-drawer
    :title="$t('title.loadingDetailEdit')"
    placement="right"
    :closable="false"
    :visible="visible"
    width="25%"
    @close="onClose">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="detail" :rules="rules" :wrapper-col="wrapperCol" style="margin-left: -2%;margin-right: 2%">
        <a-form-model-item :label="$t('business.label.customer')">
          <vxe-input :editable="false" :value="detail.customer.name" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.wave')">
          <vxe-input :editable="false" :value="detail.wave" style="width: 100%"/>
        </a-form-model-item>

        <a-divider>{{$t('business.label.reviewStatistics')}}</a-divider>
        <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
          <vxe-number-input v-model="detail.reviewStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
          <vxe-number-input v-model="detail.reviewStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
          <vxe-number-input v-model="detail.reviewStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
        </a-form-model-item>

        <a-divider>{{ $t('business.label.materialStatistics') }}</a-divider>
        <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
          <vxe-number-input v-model="detail.materialStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
          <vxe-number-input v-model="detail.materialStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
          <vxe-number-input v-model="detail.materialStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
        </a-form-model-item>

        <a-divider>{{$t('business.label.coldStatistics')}}</a-divider>
        <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
          <vxe-number-input v-model="detail.coldStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
          <vxe-number-input v-model="detail.coldStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
          <vxe-number-input v-model="detail.coldStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
        </a-form-model-item>

        <a-divider>{{ $t('business.label.shelfStatistics') }}</a-divider>
        <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
          <vxe-number-input v-model="detail.shelfStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
          <vxe-number-input v-model="detail.shelfStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
          <vxe-number-input v-model="detail.shelfStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
        </a-form-model-item>

        <a-divider>{{ $t('business.label.unDeliveryStatistics') }}</a-divider>
        <a-form-model-item :label="$t('business.label.numberOfCartonBox')">
          <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfCartonBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfInsulationBox')">
          <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfInsulationBox" :min="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.numberOfPlasticBox')">
          <vxe-number-input v-model="detail.unDeliveryStatistics.numberOfPlasticBox" :min="0" style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item>
          <a-button type="primary" @click="onClose" style="float: right">
            {{ $t('button.cancel') }}
          </a-button>
          <a-button type="primary" @click="confirm" style="float: right;margin-right: 10px">
            {{ $t('button.confirm') }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-drawer>
</template>

<script>
import { post } from '@/api/Api'
import Api from '@/api'
import { LoadingDetail } from '@/api/dto/order/LoadingOrder'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'LoadingDetailEditDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detail: new LoadingDetail(),
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      rules: {},
      order: null,
      record: null
    }
  },
  methods: {
    open(record) {
      if (record !== null && record !== undefined) {
        this.detail = new LoadingDetail(BaseObject.merge(record, 'detail'))
      }
      this.visible = true
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          post(Api.deliverySaveDetail, {}, this.detail.toJSONObject()).then(res => {
            if (res.success) {
              this.$message.success('保存成功')
              this.$emit('postSave')
              this.onClose()
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    onClose() {
      this.visible = false
      this.clear()
    },
    clear() {
      this.detail = new LoadingDetail()
    }
  }
}
</script>